function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _ from 'lodash/fp';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { getPlaceSmartSelection } from '../../redux/actions';
import { convertSelectionToRegionSelection } from '../../utilities/map';
import { INITIAL_RECTANGLE_SIZE } from '../mapView/constants';
import { MapViewContext } from '../mapView/mapViewContext';
var useSmartSelections = function() {
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var dispatch = useDispatch();
    var addFallbackSmartSelections = function() {
        if (!state.mapPlace) {
            console.error('tried to add smart selections without a map place');
            return;
        }
        actions.setRectangleToDraw({
            centre: {
                lat: state.mapPlace.geometry.location.lat(),
                lng: state.mapPlace.geometry.location.lng()
            },
            size: INITIAL_RECTANGLE_SIZE
        });
    };
    var addSmartSelections = function(smartSelections) {
        if (_.isEmpty(smartSelections)) {
            addFallbackSmartSelections();
            return;
        }
        var newSelections = smartSelections.map(function(selection) {
            return _object_spread_props(_object_spread({}, selection), {
                region: convertSelectionToRegionSelection(selection)
            });
        });
        actions.addSelections(newSelections);
        return newSelections;
    };
    var addSmartSelectionsInPlace = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(place, deliveryMethod) {
            var buttonId, smartSelections, newSelections;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        buttonId = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null;
                        return [
                            4,
                            dispatch(getPlaceSmartSelection(place, deliveryMethod, buttonId))
                        ];
                    case 1:
                        smartSelections = _state.sent();
                        newSelections = addSmartSelections(smartSelections);
                        return [
                            2,
                            newSelections
                        ];
                }
            });
        });
        return function addSmartSelectionsInPlace(place, deliveryMethod) {
            return _ref.apply(this, arguments);
        };
    }();
    return addSmartSelectionsInPlace;
};
export default useSmartSelections;
